/* eslint-disable max-len */
import { SvgIcon } from 'components/Shared/SvgIcon';
import { WithStyles } from 'decorators/withStyles';
import { IToastMessages } from 'interfaces/theme';
import * as React from 'react';
import { PureComponent } from 'react';
import rxjsOperators from 'rxjs-operators';
import themeCustomizerService from 'services/themeCustomizer';

interface IProps {
  classes?: any;
}

interface IState {
  toast: IToastMessages;
}

@WithStyles(theme => ({
  toastContainer: {
    zIndex: 999,
    position: 'fixed',
    padding: '0 20px 0 0',
    width: 60,
    maxWidth: '100%',
    height: 60,
    display: 'flex',
    alignItems: 'center',
    background: '#FFF',
    transition: 'all 0.3s ease-in-out',
    cursor: 'pointer',
    boxShadow:
      'inset 0 1px 35px 0 rgba(184, 184, 184, 0.08), 0 2px 4px 0 rgba(154, 154, 154, 0.3), 0 0 0 0 rgba(0, 0, 0, 0.15)',
    opacity: 0,
    visibility: 'hidden',
    top: 125,
    right: 5,
    margin: 'auto',
    borderRadius: 50,
    border: '1px solid #cecece',
    fontFamily: 'Open Sans',
    '&:hover': {
      boxShadow:
        'inset 0 1px 35px 0 rgba(184, 184, 184, 0.08), 0 2px 4px 0 rgba(154, 154, 154, 0.3), 0 2px 24px 0 rgba(0, 0, 0, 0.15)'
    }
  },
  active: {
    animation: 'show-component 0.3s ease-in-out forwards, expand-container 0.3s ease-in-out 1.2s forwards'
  },
  toastIcon: {
    minWidth: 40,
    minHeight: 40,
    width: 40,
    height: 40,
    display: 'flex',
    marginLeft: 10,
    alignItems: 'center',
    justifyContent: 'center',
    background: 'transparent',
    borderRadius: 50,
    transform: 'translate3d(0, 0, 0)',
    boxShadow: '0 0 0 0 #596375, 0 0 0 0 rgba(89,99,117,0.3)',
    cursor: 'pointer',
    animation: 'pulse 1.25s infinite 0.3s cubic-bezier(.66,.33,0,1)',
    fill: '#596375',
    stroke: '#596375',
    '& svg': {
      width: 25,
      height: 25
    }
  },
  toastContent: {
    padding: 20,
    color: theme.variables.colors['text'],
    '& p': {
      margin: 0,
      fontSize: 16,
      width: 0,
      overflow: 'hidden',
      transition: 'all 0.3s ease-in-out',
      opacity: 0,
      animation: 'grow-text 0.4s ease-in-out 1s forwards, show-component 0.4s ease-in-out 1.4s forwards'
    },
    '@media screen and(max - width: 480px)': {
      fontSize: 12
    }
  },
  toastClose: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    right: 10,
    color: theme.variables.colors['text'],
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    opacity: 0,
    visibility: 'hidden',
    animation: 'show-component 0.2s ease-in-out 1.8s forwards',
    fill: theme.variables.colors['text'],
    '& svg': {
      width: 14,
      height: 14
    }
  },
  '@keyframes pulse': {
    // tslint:disable-next-line:object-literal-key-quotes
    '0%': {
      boxShadow: '0 0 0 0 #596375, 0 0 0 0 rgba(89,99,117,0.3)'
    },
    '100%': {
      boxShadow: '0 0 0 12px rgba(89,99,117,0), 0 0 0 24px rgba(89,99,117,0)'
    }
  },
  '@keyframes expand-container': {
    '0%': {
      width: 60
    },
    '100%': {
      width: 600
    }
  },
  '@keyframes grow-text': {
    '0%': {
      width: 0
    },
    '100%': {
      width: '100%'
    }
  },
  '@keyframes show-component': {
    '0%': {
      opacity: 0,
      visibility: 'hidden'
    },
    '100%': {
      opacity: 1,
      visibility: 'visible'
    }
  },
  '@keyframes hide-component': {
    '0%': {
      opacity: 1,
      visibility: 'hidden'
    },
    '100%': {
      opacity: 0,
      visibility: 'visible'
    }
  }
}))
export default class ToastPreview extends PureComponent<IProps, IState> {
  componentDidMount() {
    themeCustomizerService
      .getData()
      .pipe(
        rxjsOperators.logError(),
        rxjsOperators.bindComponent(this),
        rxjsOperators.map(theme => theme.toastMessages)
      )
      .subscribe(toast => {
        toast.bgColor = `#${toast.bgColor}`;
        toast.font.color = `#${toast.font.color}`;
        this.setState({ toast });
      });
  }

  render() {
    if (!this.state) {
      return null;
    }

    const { classes } = this.props;
    const { toast } = this.state;

    return (
      <div className={`${classes.toastContainer} ${classes.active}`} style={{ backgroundColor: toast.bgColor }}>
        <div className={classes.toastIcon} style={{ fill: toast.font.color, stroke: toast.font.color }}>
          <SvgIcon name="toastIcon" />
        </div>
        <div className={`${classes.toastContent} ${classes.active}`} style={{ color: toast.font.color }}>
          <p>10 pessoas compraram este conteúdo</p>
        </div>
        <a className={classes.toastClose} style={{ fill: toast.font.color, stroke: toast.font.color }}>
          <SvgIcon name="toastClose" />
        </a>
      </div>
    );
  }
}
